import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, LiquidationtDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class AddCheckingAccountLiquidationCommand extends IRequestCommand<
  IAddCheckingAccountLiquidationResponse,
  ErrorDetails,
  IAddCheckingAccountLiquidationCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'affiCheckingAccount/{checkingAccId}/addLiquidation';
  public override setParameters(
    parameters: IAddCheckingAccountLiquidationCommandParameters
  ) {
    this._commandUrl = this._commandUrl.replace(
      '{checkingAccId}',
      parameters.checkingAccountId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IAddCheckingAccountLiquidationCommandParameters
  extends ICommandParameters,
    LiquidationtDTO {
  checkingAccountId: number;
}

export interface IAddCheckingAccountLiquidationResponse
  extends ICommandResponse {}
